import { useCallback, useEffect, useState } from 'react';
import axiosInstance from '../utils/axiosInstance';
import config from '../utils/config';
import { DefaultNewDeviceEntityPathSetting } from '../types';

// System-admin setting that decides which entity_path new devices receive
// when they are first seen by activation or reading ingestion.
export function useDefaultNewDeviceEntityPath() {
  const [path, setPath] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const baseUrl = `${config.devicesApiUrl}/system/settings/default-new-device-entity-path`;

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await axiosInstance.get<DefaultNewDeviceEntityPathSetting>(baseUrl);
      setPath(res.data.path ?? null);
    } catch (err) {
      console.error('Error fetching default new device entity path:', err);
      setError('Failed to load new device default');
    } finally {
      setLoading(false);
    }
  }, [baseUrl]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const save = useCallback(async (nextPath: string | null) => {
    const res = await axiosInstance.put<DefaultNewDeviceEntityPathSetting>(baseUrl, {
      path: nextPath,
    });
    setPath(res.data.path ?? null);
    return res.data;
  }, [baseUrl]);

  return { path, loading, error, refresh, save };
}
